import {
    SERVICE_SETTINGS_CALENDAR_TYPE_KEY,
    SERVICE_SETTINGS_SCHEDULER_TYPE_KEY,
} from '@libs/types/src/services/types/common-service-settings.type';
import { featureOn } from '../feature-flag';

export function healthcareCalendarSettingsKey(): string {
    return featureOn.HEALTHCARE_CALENDAR_MIGRATION ? SERVICE_SETTINGS_CALENDAR_TYPE_KEY : SERVICE_SETTINGS_SCHEDULER_TYPE_KEY;
}
